/* eslint-disable */
import mainMenu from 'menus/mainMenu'
import sidebarMenu from 'menus/sidebarMenu'

const routesAndMenuItems = {
  mainMenuItems: mainMenu,
  sidebarItems: sidebarMenu,
};
export default routesAndMenuItems;
